import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountdownModule } from 'ngx-countdown';

import { ComponentsModule } from '../core/components/components.module';
import { CadastroCarretaComponent } from './(MotoristaExterno)/cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { ListagemCarretaComponent } from './(MotoristaExterno)/cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { CadastroCavaloComponent } from './(MotoristaExterno)/cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { ListagemCavaloComponent } from './(MotoristaExterno)/cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { HomeComponent } from './home/home.component';
import { LoginUsuarioComponent } from './login-usuario/login-usuario.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { EmailSenhaComponent } from './recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './recuperar-senha/esqueci-senha/esqueci-senha.component';
import { ListagemServicosComponent } from './(MotoristaExterno)/servicos/listagem-servicos/listagem-servicos.component';
import { ListagemLaudosHigienizacaoComponent } from './(MotoristaExterno)/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoComponent } from './(MotoristaExterno)/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosComponent } from './(MotoristaExterno)/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { CadastroUsuarioComponent } from './(MotoristaExterno)/cadastro-usuario/cadastro-usuario.component';
import { LoginSwitchComponent } from '../core/components/login-switch/login-switch.component';
import { CadastroAgendamentoComponent } from './(MotoristaExterno)/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { CadastroPagamentoAgendamentoComponent } from './(MotoristaExterno)/agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';
import { ListagemAgendamentoComponent } from './(MotoristaExterno)/agendamento/listagem-agendamento/listagem-agendamento.component';
import { TicketAgendamentoComponent } from './(MotoristaExterno)/agendamento/ticket-agendamento/ticket-agendamento.component';
import { CadastroEmpresaComponent } from './(Empresa)/cadastro-empresa/cadastro-empresa.component';
import { CadastroAgendamentoEmpresaComponent } from './(Empresa)/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { CadastroPagamentoAgendamentoEmpresaComponent } from './(Empresa)/agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';
import { ListagemAgendamentoEmpresaComponent } from './(Empresa)/agendamento/listagem-agendamento/listagem-agendamento.component';
import { TicketAgendamentoEmpresaComponent } from './(Empresa)/agendamento/ticket-agendamento/ticket-agendamento.component';
import { CadastroCarretaEmpresaComponent } from './(Empresa)/cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { ListagemCarretaEmpresaComponent } from './(Empresa)/cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { CadastroCavaloEmpresaComponent } from './(Empresa)/cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { ListagemCavaloEmpresaComponent } from './(Empresa)/cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { CadastroMotoristaEmpresaComponent } from './(Empresa)/cadastro-frota/motorista/cadastro-motorista/cadastro-motorista.component';
import { ListagemMotoristaEmpresaComponent } from './(Empresa)/cadastro-frota/motorista/listagem-motorista/listagem-motorista.component';
import { ListagemLaudosHigienizacaoEmpresaComponent } from './(Empresa)/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoEmpresaComponent } from './(Empresa)/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosEmpresaComponent } from './(Empresa)/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { ListagemServicosEmpresaComponent } from './(Empresa)/servicos/listagem-servicos/listagem-servicos.component';
import { StepForm2Component } from './(Empresa)/agendamento/cadastro-agendamento/components/step-form-2/step-form-2.component';
import { ListagemFuncionarioEmpresaComponent } from './(Empresa)/acesso/funcionario/listagem-funcionario/listagem-funcionario.component';
import { CadastroFuncionarioEmpresaComponent } from './(Empresa)/acesso/funcionario/cadastro-funcionario/cadastro-funcionario.component';

const empresaModules = [
  CadastroAgendamentoEmpresaComponent,
  CadastroCavaloEmpresaComponent,
  ListagemServicosEmpresaComponent,
  CadastroLaudoHigienizacaoEmpresaComponent,
  CadastroEntradaServicosEmpresaComponent,
  ListagemLaudosHigienizacaoEmpresaComponent,
  ListagemCavaloEmpresaComponent,
  ListagemMotoristaEmpresaComponent,
  CadastroMotoristaEmpresaComponent,
  CadastroEmpresaComponent,
  ListagemAgendamentoEmpresaComponent,
  TicketAgendamentoEmpresaComponent,
  CadastroCarretaEmpresaComponent,
  ListagemCarretaEmpresaComponent,
  CadastroPagamentoAgendamentoEmpresaComponent,
  ListagemFuncionarioEmpresaComponent,
  CadastroFuncionarioEmpresaComponent
];

const motoristaExternoModules = [
  CadastroCarretaComponent,
  ListagemCarretaComponent,
  CadastroCavaloComponent,
  ListagemCavaloComponent,
  ListagemServicosComponent,
  ListagemLaudosHigienizacaoComponent,
  CadastroLaudoHigienizacaoComponent,
  CadastroEntradaServicosComponent,
  CadastroUsuarioComponent,
  CadastroAgendamentoComponent,
  ListagemAgendamentoComponent,
  TicketAgendamentoComponent
];

@NgModule({
  declarations: [
    ...empresaModules,
    ...motoristaExternoModules,
    CadastroPagamentoAgendamentoComponent,
    LoginSwitchComponent,
    HomeComponent,
    LoginUsuarioComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    NotFoundComponent,
    StepForm2Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    ComponentsModule
  ],
  exports: [
    ...empresaModules,
    ...motoristaExternoModules,
    CadastroPagamentoAgendamentoComponent,
    LoginSwitchComponent,
    HomeComponent,
    LoginUsuarioComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    NotFoundComponent
  ]
})
export class PagesModule {}
